export const tableConfiguration = {
  tableHeaderBackground: "#D4EEFD",
  tableHeaderPadding: "10px 0px 10px 12px",
  tableRowPadding: "10px 0px 10px 12px",
  tableRowBorder: "1px solid #E0E0E0",
  tableRowBorderRadius: "5px 5px 0 0",
  tableRowBorderBottom: "1px solid #E0E0E0",
  tableRowBorderBottomRadius: "5px 5px 0 0",
  tableHeaderBorderRadius: "10px 10px 0 0",
};
